import React from "react";

import { cn } from "../../../../lib/utils";
import { Input } from "../../ui/Input";
import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "../../ui/Form";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBan} from "@fortawesome/pro-solid-svg-icons";

const HouseNumber = ({ methods, isOpen: { HouseNumber } }) => {
    const { control, register } = methods;
    return (
        <div
            className={cn(
                "section grid grid-cols-1 gap-8 transition-all opacity-0 h-0 ",
                {
                    ["h-full opacity-100"]: HouseNumber.isOpen,
                }
            )}
        >
            <div className="flex items-center justify-start gap-4">
                <div className="group">
                    <div
                        className="flex flex-col items-center justify-start relative group-has-[:checked]:border group-has-[:checked]:bg-[#555454]  p-1">
                        <div className='h-[84px] w-[79px]  flex items-center justify-center'>
                            <FontAwesomeIcon className='w-full h-12 text-gray-600 group-has-[:checked]:text-white'
                                             icon={faBan}/>
                        </div>
                        <span className="text-xs  text-gray-600 group-has-[:checked]:text-white">
                            none
                        </span>
                        <input
                            value="none"
                            type="radio"
                            className="absolute inset-0 h-full w-full opacity-0 z-10 cursor-pointer"
                            {...register("house_number_style")}
                        />
                    </div>
                </div>
                <div className="group">
                    <div
                        className="flex flex-col items-center justify-start relative group-has-[:checked]:border group-has-[:checked]:bg-[#555454] p-1">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="79"
                            height="84"
                            viewBox="0 0 79 84"
                        >
                            <text
                                transform="translate(0.5 62.5)"
                                fill="#e3e3e3"
                                stroke="#707070"
                                strokeWidth="0.5"
                                fontSize="57"
                                fontFamily="Erbaum-Bold, Erbaum"
                                fontWeight="700"
                            >
                                <tspan x="0" y="0">
                                    1a
                                </tspan>
                            </text>
                        </svg>
                        <span className="text-xs text-gray-700 group-has-[:checked]:text-white text-center">
                            Stainless Steel
                        </span>
                        <input
                            value="stainless steel"
                            type="radio"
                            className="absolute inset-0 h-full w-full opacity-0 z-10 cursor-pointer"
                            {...register("house_number_style")}
                        />
                    </div>
                </div>
                <div className="group">
                    <div
                        className="flex flex-col items-center justify-start relative group-has-[:checked]:border group-has-[:checked]:bg-[#555454] p-1">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="79"
                            height="84"
                            viewBox="0 0 79 84"
                        >
                            <text
                                transform="translate(0.5 62.5)"
                                fill="#141414"
                                stroke="#707070"
                                strokeWidth="0.5"
                                fontSize="57"
                                fontFamily="Erbaum-Bold, Erbaum"
                                fontWeight="700"
                            >
                                <tspan x="0" y="0">
                                    1a
                                </tspan>
                            </text>
                        </svg>

                        <span className="text-xs text-gray-700 group-has-[:checked]:text-white text-center">
                            Stainless Steel Black
                        </span>
                        <input
                            value="steel black"
                            type="radio"
                            className="absolute inset-0 h-full w-full opacity-0 z-10 cursor-pointer"
                            {...register("house_number_style")}
                        />
                    </div>
                </div>
            </div>
            <FormField
                control={control}
                name="house_number"
                render={({field}) => (
                    <FormItem>
                        <FormLabel className="text-gray-700">
                            House Number
                        </FormLabel>
                        <FormControl>
                            <Input
                                type="text"
                                icon
                                className="text-gray-700"
                                placeholder="Enter House Number"
                                {...field}
                                maxLength={3}
                            />
                        </FormControl>
                        <FormMessage/>
                    </FormItem>
                )}
            />
        </div>
    );
};

export default HouseNumber;
